import React from 'react'
import { clsx } from 'clsx'

type BaseRadio = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

export type InputRadioProps = Omit<BaseRadio, 'type' | 'checked' | 'onChange'> & {
  value: string
  checked: boolean
  onChange: (value: string) => void
  label?: string
}

export const InputRadio = ({ value, checked, onChange, label, ...rest }: InputRadioProps) => {
  return (
    <div className="tw-flex tw-items-center tw-text-sm">
      <input type="radio" className="tw-sr-only" checked={checked} onChange={() => onChange(value)} {...rest} />
      <div
        className={clsx(
          'tw-w-5 tw-h-5 tw-rounded-full tw-border tw-border-input tw-mr-2',
          'tw-flex tw-items-center tw-justify-center',
          'tw-transition-colors tw-duration-200',
          !checked && 'tw-bg-input-fill',
        )}
        style={checked ? { backgroundColor: 'var(--primary-500)', borderColor: 'var(--primary-500)' } : undefined}
        onClick={() => onChange(value)}
      >
        {checked && <div className="tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-surface" />}
      </div>
      {label && (
        <label className="tw-text-input" onClick={() => onChange(value)}>
          {label}
        </label>
      )}
    </div>
  )
}
